import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs';

import {map} from 'rxjs/operators';
import {PAGE_STATE_RESET, PageStateResetAction, REFRESH_DATA, RefreshDataAction} from './vorlage-auswaehlen.actions.ui';
import {GetIncidentVorlagenListeAction} from '../../../../client-ngrx/incidents';


@Injectable()
export class VorlageAuswaehlenPageUiEffects {

    datenLaden$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<PageStateResetAction>(PAGE_STATE_RESET),
        map(() => {
            return new GetIncidentVorlagenListeAction();
        })
    ));

    refreshData$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType<RefreshDataAction>(REFRESH_DATA),
        map(() => {
            return new GetIncidentVorlagenListeAction();
        })
    ));

    constructor(private actions$: Actions,
                private store$: Store<any>) {
    }

}
